export type ConsumerFunction<T> = (data: T) => void

export abstract class EventBus<T> {
  abstract on(callback: (data: T) => void): void

  abstract off(): void

  abstract emit(data: T): void
}

export abstract class SingleListenerEventBus<T> extends EventBus<T> {
  protected listener: (data: T) => void = null

  public on(callback: (data: T) => void): void {
    this.listener = callback
  }

  public off(): void {
    this.listener = null
  }

  abstract emit(data: T): void
}

export class SimpleEventBus<T> extends SingleListenerEventBus<T> {
  public emit(data: T): void {
    if (this.listener) this.listener(data)
  }
}
